"use client";

import React from "react";
import Link from "next/link";

const footerLinks = [
  { name: "Privacy", href: "/privacy" },
  { name: "Terms", href: "/terms" },
];

export const Footer = () => {
  return (
    <footer className="border-t border-[#2A2A2A] mt-auto">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-10 pb-28 sm:pb-10">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="flex items-center gap-6">
            <span className="text-sm font-bold text-white tracking-[-0.5px]">Probabl</span>
            {footerLinks.map((link) => (
              <Link
                key={link.name}
                href={link.href}
                className="text-[#808080] hover:text-white transition-colors text-sm"
              >
                {link.name}
              </Link>
            ))}
          </div>
          <span className="text-[#4D4A46] text-xs">
            &copy; {new Date().getFullYear()} Probabl. For entertainment only.
          </span>
        </div>
      </div>
    </footer>
  );
};
